import React from 'react'
import { Redirect, Route } from 'react-router'

export default function PrivateRoute({ children, ...rest }) {

  const accessTokenLocal = localStorage.getItem("APP_ACCESS_TOKEN");

  return (
    <Route
      {...rest}
      render={({ location }) =>
        accessTokenLocal !== null && accessTokenLocal !== undefined && accessTokenLocal !== "" ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: location }
            }}
          />
        )
      }
    />
  );
}